<template>
  <div id="app">
    <index></index>
  </div>
</template>
<script>
import index from "../src/views/index/index.vue";
export default {
  components: {
    index,
  },
};
</script>
<style>
#app {
  box-sizing: border-box;
}
</style>

